import { Descriptions, Space, Button, Typography, List } from "@mimber/ui-web"
import type { ReviewStepProps } from "./ReviewStep.types"

const { Paragraph } = Typography

export const ReviewStep: React.FunctionComponent<ReviewStepProps> = ({
  file,
  mapping,
  fieldDefinitions,
  isPending,
  onBack,
  onConfirm,
}) => {
  const fieldLabel = (key: string) =>
    fieldDefinitions.find((field) => field.key === key)?.label ?? key

  const mappingEntries = Object.entries(mapping)

  return (
    <Space direction="vertical" style={{ width: "100%" }} size="middle">
      <Paragraph type="secondary">
        Review your file and column mapping before starting the import.
        Processing happens in the background — you'll be emailed once it's
        complete.
      </Paragraph>

      <Descriptions bordered column={1} size="small">
        <Descriptions.Item label="File">{file.name}</Descriptions.Item>
        <Descriptions.Item label="Mapped columns">
          {mappingEntries.length}
        </Descriptions.Item>
      </Descriptions>

      <List
        size="small"
        header="Column mapping"
        bordered
        dataSource={mappingEntries}
        renderItem={(entry: [string, string]) => {
          const [csvHeader, fieldKey] = entry
          return (
            <List.Item>
              {csvHeader} → {fieldLabel(fieldKey)}
            </List.Item>
          )
        }}
      />

      <Space>
        <Button onClick={onBack} disabled={isPending}>
          Back
        </Button>
        <Button type="primary" onClick={onConfirm} loading={isPending}>
          Confirm import
        </Button>
      </Space>
    </Space>
  )
}
